@if (!feltsArray) {
    <div class="container" [ngClass]="{'dialog-background': sopoDialogRef}">
        <ng-container *ngIf="(myFelts$ | async) && (activeFelt$ | async); else loading">
            <div class="felt-items community-felt-item" (click)="openCommunityFeltMenu()" [ngClass]="{ 'item-border': (activeFelt$ | async).type == 'externalUrl' }">
                <div class="community-felt-text">Community Felts</div>
            </div>
            <div
                class="felt-items"
                *ngFor="let item of (myFelts$ | async); trackBy: trackFelts"
                (click)="onSelect(item)"
                [ngStyle]="getFelt(item.id)"
                [ngClass]="{ 'item-border': (activeFelt$ | async).id == item.id }">
                <img class="sopo-logo" src="/assets/img/SOPO-black.png">
            </div>
        </ng-container>
    </div>

    <ng-template #loading>
        <sopo-loader-dots [type]="'two'"></sopo-loader-dots>
    </ng-template>
} @else {
    <div class="community-felt-container" (click)="openCommunityFeltMenu()">
        <div class="community-felt-wrapper">
            <div class="community-felt-item" [ngClass]="{ 'item-border': (activeFelt$ | async)?.type == 'externalUrl' }">
                <div class="community-felt-text">Community Felts</div>
            </div>
            <label class="name-tag">Open Menu</label>
        </div>
        <div class="divider"></div>
    </div>
    <swiper
        felt_swiper
        [config]="sliderOptions"
        class="swiper"
        #feltSlide
    >
        <ng-template
            swiperSlide
            *ngFor="let item of (myFelts$ | async); trackBy: trackFelts"
        >
            <div
                class="wrapper"
                (click)="onSelect(item)"
            >
                <div
                    class="felt-items-swiper"
                    [ngStyle]="getFelt(item.id)"
                    [ngClass]="{ 'item-border': (activeFelt$ | async)?.id == item.id }"
                >
                    <img class="sopo-logo" src="/assets/img/SOPO-black.png">
                </div>
                <label class="name-tag">
                    {{ item.name.length > 10 ? (item.name | slice:0:10) : item.name }}
                </label>
            </div>
        </ng-template>
    </swiper>
}
